// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tIiU","colBig":"styles_colBig__YP1_p","colSmall":"styles_colSmall__3g4vF"};